// import Submit from '../Submit';

import styled from 'styled-components'

import dropboxIcon from '../../assets/dropbox-icon.svg'

const Button = styled.div`
    font-size: 14px;
    line-height: 16px;
    color: #606060;

    display: flex;
    flex-direction: column;
    width: 124px;
    height: 92px;

    align-items: center;
    justify-content: center;

    background: rgba(255, 255, 255, 0.6);
    border-radius: 8px;

    cursor: pointer;
    background: rgba(255, 255, 255, 0.6);

    transition: background .2s;
    z-index: 1;

    &:hover {
        background: #F4F3F4;
    }

    &:first-child {
        margin-left: 0;
    }

    @media (min-width: 480px) {
        width: 96px;
    }
`
Button.displayName = 'Service-Button'

const Icon = styled.div`
    width: 48px;
    height: 46px;
    background-image: url(${dropboxIcon});
`
Icon.displayName = 'Service-Icon'


type Props = {
    callback: (url: string) => void,
}

const DropboxButton = ({ callback }: Props) => {
    const options = {
        // Required. Called when a user selects an item in the Chooser.
        success: function(files: any) {
            callback(files[0].link)
        },
        sizeLimit: 1024 * 1024 * 25,
        extensions: ['.pdf'],
        linkType: 'direct',
    };

    // return <Submit onClick={()=> {
    //     // @ts-ignore
    //     if (window.Dropbox !== undefined) {
    //         // @ts-ignore
    //         window.Dropbox.choose(options)
    //     }
    // }}>
    //     Connect to Dropbox
    // </Submit>

    return <Button onClick={() => {
        // @ts-ignore
        if (window.Dropbox !== undefined) {
            // @ts-ignore
            window.Dropbox.choose(options)
        }
    }}>
        <Icon />
        Dropbox
    </Button>
}

export default DropboxButton
